window.init_graph_statistics=function(){
    
    if($('.category_list0').is(':disabled')){
      $('.category_list9').click();
    }else{
      $('.category_list0').click();
    }
    var $active = $('#accordion .panel-collapse.in').prev().addClass('active');
    $active.find('a').children().remove()
    // $active.find('a').prepend('<i class="glyphicon glyphicon-minus"></i>');
    // $('#accordion .panel-heading').not($active).find('a').children().remove()
    // $('#accordion .panel-heading').not($active).find('a').prepend('<i class="glyphicon glyphicon-plus"></i>');
    $('#accordion').on('show.bs.collapse', function (e) {
        $('#accordion .panel-heading.active').removeClass('active').find('.glyphicon').toggleClass('glyphicon-plus glyphicon-minus');
        $(e.target).prev().addClass('active').find('.glyphicon').toggleClass('glyphicon-plus glyphicon-minus');
    });
}